<template>
  <div class="UpgradeToGold">
    <div class="subscriptions-block multi-block">

      <v-row justify="center">
        <v-expansion-panels accordion :value="value" id="masterpyq-upgrade">
          <v-expansion-panel v-if="isDivVisible('MASTERPYQ')">
            <v-expansion-panel-header expand-icon="mdi-menu-down">
              <div class="subscriptions-title">
                <div class="icon-top-1 icon-top-test">
                  <img
                    class="test-sub-icon"
                    src="../../../assets/img/svg/test-icon.svg"
                  />
                </div>
                <div class="top-title-1 top-title-test">
                  Master PYQs
                </div>
                <img
                  class="down-arrow-header-icon"
                  src="../../../assets/img/svg/down-header-arrow.png"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div>
                  <div class="subscriptions-content subscriptions-content-1">
                    <div class="subscription-description">
                      Master Previous Years Questions (PYQs) to strengthen your preparation with comprehensive question banks.
                    </div>
                    <v-row v-for="(pkg, j) in packages" :key="pkg.id" class="row-wrap">
                      <v-col
                        class="d-flex flex-column"
                        v-for="(prodObj, i) in pkg.product_list"
                        :key="prodObj.id"
                        rows="3"
                        sm="3"
                        v-if="pkg.product_type == 'MASTERPYQ' && getIsInstitutePurchased(prodObj) && shouldShowMasterPyqProduct(prodObj)"
                      >
                        <v-card
                          :class="[
                            prodObj.isAdded == 1
                              ? 'added-grey-color-border'
                              : '',
                            !prodObj.isAdded && prodObj.is_purchased == 0
                              ? 'skyblue-color-border'
                              : '',
                            prodObj.is_purchased == 1
                              ? 'purchased-darkblue-color-border'
                              : '',
                          ]"
                          class="pa-2 flex d-flex flex-column zero-padding-card"
                          tile
                          outlined
                        >
                          <div
                            class="pkg-title"
                            :class="[
                              prodObj.isAdded == 1 ? 'added-grey-color' : '',
                              !prodObj.isAdded && prodObj.is_purchased == 0
                                ? 'skyblue-color'
                                : '',
                              prodObj.is_purchased == 1
                                ? 'purchased-darkblue-color'
                                : '',
                            ]"
                          >
                            {{ prodObj.name }}
                          </div>
                          <v-card-text class="flex product-description">
                            <div v-html="prodObj.desc"></div>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <div class="pack-price">
                              &#8377; {{ prodObj.price }}
                            </div>
                          </v-card-actions>
                        </v-card>
                        <div class="text-center space-btn">
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 1 ||
                                prodObj.is_purchased == 1||( !getIsProductPurchased(prodObj))
                            "
                            :color="
                              prodObj.is_purchased == 1 ||
                              prodObj.institute_purchased == 1 || (!getIsProductPurchased(prodObj))
                                ? 'purchased-darkblue-color'
                                : ''
                            "
                            class="add-cart btn-1"
                            :class="
                              prodObj.is_purchased == 1 &&
                              prodObj.institute_purchased == 0&& getIsProductPurchased(prodObj)
                                ? 'student-purchase'
                                : 'institute-purchase'
                            "
                            >{{
                              prodObj.is_purchased == 1 
                                ? "Purchased"
                                : prodObj.institute_purchased == 1 ||( !getIsProductPurchased(prodObj))
                                ? "Institute Purchased"
                                : ""
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            :color="
                              prodObj.isAdded ? 'default' : 'skyblue-color'
                            "
                            class="add-cart"
                            :disabled="prodObj.isDisabled"
                            @click="
                              addToCart(pkg, j, prodObj, i, prodObj.parent)
                            "
                            >{{
                              prodObj.isAdded ? "Added" : "Add to Cart"
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            type="button"
                            :disabled="prodObj.isDisabled"
                            :color="
                              prodObj.is_purchased == 0 ? 'yellow-color' : ''
                            "
                            class="add-cart btn-2"
                            @click="alertGSTBeforePurchase([prodObj])"
                          >
                            Buy Now</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row justify="center">
        <v-expansion-panels accordion>
          <v-expansion-panel v-if="isDivVisible('PREYEAR')">
            <v-expansion-panel-header expand-icon="mdi-menu-down">
              <div class="subscriptions-title">
                <div class="icon-top-1 icon-top-test">
                  <img
                    class="test-sub-icon"
                    src="../../../assets/img/svg/test-icon.svg"
                  />
                </div>
                <div class="top-title-1 top-title-test">
                  Previous Years Papers
                </div>
                <img
                  class="down-arrow-header-icon"
                  src="../../../assets/img/svg/down-header-arrow.png"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div>
                  <div class="subscriptions-content subscriptions-content-1">
                    <div class="subscription-description">
                      Answer the Question Papers asked in the Previous Years in
                      your target exams.
                    </div>

                    <v-row v-for="(pkg, j) in packages" :key="pkg.id">
                      <v-col
                        class="d-flex flex-column"
                        v-for="(prodObj, i) in pkg.product_list"
                        :key="prodObj.id"
                        cols="3"
                        sm="3"
                        v-if="pkg.product_type == 'PREYEAR' && getIsInstitutePurchased(prodObj)"
                      >
                        <v-card
                          :class="[
                            prodObj.isAdded == 1
                              ? 'added-grey-color-border'
                              : '',
                            !prodObj.isAdded && prodObj.is_purchased == 0
                              ? 'skyblue-color-border'
                              : '',
                            prodObj.is_purchased == 1
                              ? 'purchased-darkblue-color-border'
                              : '',
                          ]"
                          class="pa-2 flex d-flex flex-column zero-padding-card"
                          tile
                          outlined
                        >
                          <div
                            class="pkg-title"
                            :class="[
                              prodObj.isAdded == 1 ? 'added-grey-color' : '',
                              !prodObj.isAdded && prodObj.is_purchased == 0
                                ? 'skyblue-color'
                                : '',
                              prodObj.is_purchased == 1
                                ? 'purchased-darkblue-color'
                                : '',
                            ]"
                          >
                            {{ prodObj.name }}
                          </div>
                          <v-card-text class="flex product-description">
                            <div v-html="prodObj.desc"></div>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <div class="pack-price">
                              &#8377; {{ prodObj.price }}
                            </div>
                          </v-card-actions>
                        </v-card>
                        <div class="text-center space-btn">
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 1 ||
                                prodObj.is_purchased == 1 || !getIsProductPurchased(prodObj)
                            "
                            :color="
                              prodObj.is_purchased == 1 || prodObj.institute_purchased == 1 || !getIsProductPurchased(prodObj)
                                ? 'purchased-darkblue-color'
                                : ''
                            "
                            class="add-cart btn-1"
                            :class="
                              prodObj.is_purchased == 1 &&
                              prodObj.institute_purchased == 0 &&  getIsProductPurchased(prodObj)
                                ? 'student-purchase'
                                : 'institute-purchase'
                            "
                            >{{
                              prodObj.is_purchased == 1
                                ? "Purchased"
                                : prodObj.institute_purchased == 1 || (!getIsProductPurchased(prodObj))
                                ? "Institute Purchased"
                                : ""
                            }}</v-btn
                          >
                          <v-btn
                            :color="
                              prodObj.isAdded ? 'default' : 'skyblue-color'
                            "
                            class="add-cart"
                            :disabled="prodObj.isDisabled"
                            @click="
                              addToCart(pkg, j, prodObj, i, prodObj.parent)
                            "
                            v-else
                            >{{
                              prodObj.isAdded ? "Added" : "Add to Cart"
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            type="button"
                            :disabled="prodObj.isDisabled"
                            :color="
                              prodObj.is_purchased == 0 ? 'yellow-color' : ''
                            "
                            class="add-cart btn-2"
                            @click="alertGSTBeforePurchase([prodObj])"
                          >
                            Buy Now</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row justify="center">
        <v-expansion-panels accordion :value="value">
          <v-expansion-panel v-if="isDivVisible('AITS')">
            <v-expansion-panel-header expand-icon="mdi-menu-down">
              <div class="subscriptions-title">
                <div class="icon-top-1 icon-top-test">
                  <img
                    class="test-sub-icon"
                    src="../../../assets/img/svg/test-icon.svg"
                  />
                </div>
                <div class="top-title-1 top-title-test">
                  All India Test Series
                </div>
                <img
                  class="down-arrow-header-icon"
                  src="../../../assets/img/svg/down-header-arrow.png"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div>
                  <div class="subscriptions-content subscriptions-content-1">
                    <div class="subscription-description">
                      All India Test Series (A.I.T.S) Helps you understand your
                      standing in comparison to your competition.
                    </div>
                    <v-row v-for="(pkg, j) in packages" :key="pkg.id" class="row-wrap">
                      <v-col
                        class="d-flex flex-column"
                        v-for="(prodObj, i) in pkg.product_list"
                        :key="prodObj.id"
                        rows="3"
                        sm="3"
                        v-if="pkg.product_type == 'AITS' && getIsInstitutePurchased(prodObj)"
                      >
                        <v-card
                          :class="[
                            prodObj.isAdded == 1
                              ? 'added-grey-color-border'
                              : '',
                            !prodObj.isAdded && prodObj.is_purchased == 0
                              ? 'skyblue-color-border'
                              : '',
                            prodObj.is_purchased == 1
                              ? 'purchased-darkblue-color-border'
                              : '',
                          ]"
                          class="pa-2 flex d-flex flex-column zero-padding-card"
                          tile
                          outlined
                        >
                          <div
                            class="pkg-title"
                            :class="[
                              prodObj.isAdded == 1 ? 'added-grey-color' : '',
                              !prodObj.isAdded && prodObj.is_purchased == 0
                                ? 'skyblue-color'
                                : '',
                              prodObj.is_purchased == 1
                                ? 'purchased-darkblue-color'
                                : '',
                            ]"
                          >
                            {{ prodObj.name }}
                          </div>
                          <v-card-text class="flex product-description">
                            <div v-html="prodObj.desc"></div>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <div class="pack-price">
                              &#8377; {{ prodObj.price }}
                            </div>
                          </v-card-actions>
                        </v-card>
                        <div class="text-center space-btn">
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 1 ||
                                prodObj.is_purchased == 1||( !getIsProductPurchased(prodObj))
                            "
                            :color="
                              prodObj.is_purchased == 1 ||
                              prodObj.institute_purchased == 1 || (!getIsProductPurchased(prodObj))
                                ? 'purchased-darkblue-color'
                                : ''
                            "
                            class="add-cart btn-1"
                            :class="
                              prodObj.is_purchased == 1 &&
                              prodObj.institute_purchased == 0&& getIsProductPurchased(prodObj)
                                ? 'student-purchase'
                                : 'institute-purchase'
                            "
                            >{{
                              prodObj.is_purchased == 1 
                                ? "Purchased"
                                : prodObj.institute_purchased == 1 ||( !getIsProductPurchased(prodObj))
                                ? "Institute Purchased"
                                : ""
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            :color="
                              prodObj.isAdded ? 'default' : 'skyblue-color'
                            "
                            class="add-cart"
                            :disabled="prodObj.isDisabled"
                            @click="
                              addToCart(pkg, j, prodObj, i, prodObj.parent)
                            "
                            >{{
                              prodObj.isAdded ? "Added" : "Add to Cart"
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            type="button"
                            :disabled="prodObj.isDisabled"
                            :color="
                              prodObj.is_purchased == 0 ? 'yellow-color' : ''
                            "
                            class="add-cart btn-2"
                            @click="alertGSTBeforePurchase([prodObj])"
                          >
                            Buy Now</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      
      <v-row justify="center">
        <v-expansion-panels accordion>
          <v-expansion-panel v-if="isDivVisible('PROFICIENCY')">
            <v-expansion-panel-header expand-icon="mdi-menu-down">
              <div class="subscriptions-title">
                <div class="icon-top-1 icon-top-test">
                  <img
                    class="test-sub-icon"
                    src="../../../assets/img/svg/test-icon.svg"
                  />
                </div>
                <div class="top-title-1 top-title-test">
                  Proficiency Tests
                </div>
                <img
                  class="down-arrow-header-icon"
                  src="../../../assets/img/svg/down-header-arrow.png"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div>
                  <div class="subscriptions-content subscriptions-content-1">
                    <div class="subscription-description">
                      Answer the Question Papers asked in the Previous Years in
                      your target exams.
                    </div>
                    <v-row v-for="(pkg, j) in packages" :key="pkg.id" class="row-wrap">
                      <v-col
                        class="d-flex flex-column"
                        v-for="(prodObj, i) in pkg.product_list"
                        :key="prodObj.id"
                        rows="3"
                        sm="6"
                        v-if="pkg.product_type == 'PROFICIENCY' && getIsInstitutePurchased(prodObj)"
                      >
                        <v-card
                          class="pa-2 flex d-flex flex-column zero-padding-card"
                          tile
                          outlined
                        >
                          <div
                            class="pkg-title"
                            :class="[
                              prodObj.is_purchased == 1 &&
                              prodObj.institute_purchased == 1 && !getIsProductPurchased(prodObj)
                                ? 'added-grey-color'
                                : '',
                              prodObj.institute_purchased == 0 &&
                              prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                                ? 'skyblue-color'
                                : '',
                              prodObj.is_purchased == 1
                                ? 'purchased-darkblue-color'
                                : '',
                            ]"
                          >
                            {{ prodObj.name }}
                          </div>
                          <v-card-text class="flex product-description">
                            <div v-html="prodObj.desc"></div>
                          </v-card-text>
                          <v-card-actions class="justify-left">
                            <div class="pack-price">
                              &#8377; {{ prodObj.price }}
                            </div>
                          </v-card-actions>
                        </v-card>
                        <div class="text-center space-btn">
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 1 ||
                                prodObj.is_purchased == 1 || ( !getIsProductPurchased(prodObj))
                            "
                            :color="
                              prodObj.is_purchased == 1 ||
                              prodObj.institute_purchased == 1 || ( !getIsProductPurchased(prodObj))
                                ? 'purchased-darkblue-color'
                                : ''
                            "
                            class="add-cart btn-1"
                            :class="
                              prodObj.is_purchased == 1 &&
                              prodObj.institute_purchased == 0  &&getIsProductPurchased(prodObj)
                                ? 'student-purchase'
                                : 'institute-purchase'
                            "
                            >{{
                              prodObj.is_purchased == 1
                                ? "Purchased"
                                : prodObj.institute_purchased == 1 || (!getIsProductPurchased(prodObj))
                                ? "Institute Purchased"
                                : ""
                            }}</v-btn
                          >
                          <v-btn
                            :color="
                              prodObj.isAdded ? 'default' : 'skyblue-color'
                            "
                            class="add-cart"
                            :disabled="prodObj.isDisabled"
                            @click="
                              addToCart(pkg, j, prodObj, i, prodObj.parent)
                            "
                            v-else
                            >{{
                              prodObj.isAdded ? "Added" : "Add to Cart"
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              prodObj.institute_purchased == 0 &&
                                prodObj.is_purchased == 0 && getIsProductPurchased(prodObj)
                            "
                            type="button"
                            :color="'yellow-color'"
                            class="add-cart btn-2"
                            @click="alertGSTBeforePurchase([prodObj])"
                          >
                            Buy Now</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <div class="showCart">
        <v-row v-if="showCart()">
          <v-col cols="6" sm="6">
            <div class="cart-title">
              Your Cart
              <v-icon>mdi-cart</v-icon>
            </div>
            <ol>
              <div v-for="pkg in packages" :key="pkg.id">
                <template v-for="product in pkg.product_list">
                  <li
                    class="added-list"
                    v-if="product.isAdded"
                    :key="product.id"
                  >
                    <div class="added-item">
                      Premium Papers - {{ product.name }}
                      <v-icon
                        small
                        @click="removeFromCart(product, product.parent)"
                        >mdi-delete</v-icon
                      >
                    </div>
                  </li>
                </template>
              </div>
            </ol>
            <div class="cart-btn">
              <v-btn
                class="right-btn cust-btn clear-cart-UI"
                @click="modifyResetPackageData()"
                >Clear Cart</v-btn
              >
            </div>
          </v-col>
          <v-col cols="6" sm="6">
            <div>
              <div class="cart-title-text">Total Amount Payable</div>
              <div class="card-price">
                <span>&#8377; {{ parseInt(currentAmount()) }}</span> (Inclusive of
                all taxes)
              </div>
              <div class="check-aggrement">
                <div class="check-cust">
                  <v-checkbox v-model="isAgreed"></v-checkbox>
                </div>
                <div class="agree-text">I agree with the</div>
                <div class="terms-text" @click="showTermsAndConditions">
                  Terms and Conditions.
                </div>
              </div>
              <div class="cart-btn">
                <v-btn
                  :disabled="!isProductAdded || !isAgreed "
                  color="primary"
                  @click="buyCartPackages()"
                  class="right-btn cust-btn pay-now-btn"
                  >Pay Now</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
<PaymentHiddenInput :order="order"/>

      <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertBoxData"
        :contentClass="contentClass"
        :success="success"
        :failure="failure"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from "vuex";
import constants from '../../../utils/constants';
import PaymentHiddenInput from '../../coordinator/subscription-details/PaymentHiddenInput.vue';
export default {
  name: "PackagesList",
  components:{
PaymentHiddenInput
  },
  mounted() {
    this.checkForStatus();
    if(this.user.institute == constants.ONLINE_INSTITUTE_ID){
      this.value = 0;
    }
    setTimeout(()=>{
      this.modifyResetPackageData();
      this.scrollToView();
      },1000)
    
  },
  props: ["packages", "route"],
  watch: {
    route(newRoute, oldRoute) {
      
      this.scrollToView();
    }
  },
  computed: {},
  data() {
    return {
      isAgreed: false,
      cComponent: "",
      modalwidth: null,
      status: false,
      alertBoxData: {},
      pdfLink: require("@/assets/publication-schedule/TestPublicationSchedule.pdf"),
      orderId: null,
      onPopUpTermsAndConditions: false,
      value: null,
      isProductAdded: false,
      order:null,
      success: false,
      failure: false,
      contentClass: ""
     };
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  methods: {
    ...mapActions({
      getPackages: "userStore/getPackages",
      updateTransactionStatus: "userStore/updateTransactionStatus",
      createPackageOrder: "userStore/createPackageOrder",
      me: "userStore/me",
      getPriceDetails : "userStore/getPriceDetails"
    }),
    scrollToView() {
      let routeName = this.route;
      if(routeName && routeName.includes('masterpyq-upgrade')){
        const element = document.getElementById('masterpyq-upgrade');
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        const element = document.getElementById('readymade-test-upgrade');
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    checkCart(){
      let i=0;
      this.packages.map((pkg) => {
      pkg.product_list.map((p) => {
        if(p.isAdded){
          i++;
        }
      });
      });
      if(i<1){
          this.isProductAdded = false;
        }
    },
    removeFromCart(product) {
      product.isAdded = false;
      product.parent
        ? this.onChildRemove(product)
        : this.onParentRemove(product);

        this.checkCart();
    },
    onParentRemove(product) {
      product.pkg.product_list.map((p) => {
        if (p.parent == product.id) {
          p.isDisabled = false;
        }
      });
    },
    onChildRemove(product) {
      const parent = product.pkg.product_list.find(
        (p) => p.id == product.parent
      );
      parent.isDisabled =
        product.pkg.product_list.filter((p) => {
          return p.parent == parent.id && (p.isAdded || p.is_purchased);
        }).length > 0;
    },
    onParentAdd(product) {
      product.pkg.product_list.map((p) => {
        if (p.parent == product.id) {
          p.isDisabled = true;
        }
      });
    },
    onChildAdd(product) {
      product.pkg.product_list.map((p) => {
        if (p.id == product.parent) {
          p.isDisabled = true;
        }
      });
    },
    showTermsAndConditions(data) {
      this.alertBoxData = {};
      this.alertBoxData.persistent = true;
      this.alertBoxData.showTermsAndConditions = data.showTermsAndConditions
      this.alertBoxData.prodObj = data.prodObj;
      this.modalwidth = "500px";
      this.status = true;
      this.cComponent = "components/student/UpgradeToGold/TermsAndCondition";
    },
    alertGSTBeforePurchase(prodObj) {
      let reqData = {
        product_ids : prodObj.map((x) => x.id)
      }
      this.getPriceDetails(reqData)
      .then((response) => {
        this.alertBoxData = {};
        this.alertBoxData.persistent = true;
        this.alertBoxData.prodObj = prodObj;
        this.alertBoxData.priceDetails = response;
        this.modalwidth = "500px";
        this.status = true;
        this.cComponent = "components/student/UpgradeToGold/GstChargesPopUp";
      })
      .catch((e) => {
        console.log(e);
      })
    },
    onClose(data) {
      if(data.payNow && data.prodObj && data.prodObj.length > 1){
        this.buyPackages(data.couponCode,data.gstNumber);
      }else if(data.payNow && data.prodObj && data.prodObj.length == 1) {
        this.buyNow(data.prodObj[0].id,data.couponCode,data.gstNumber);
      }
      else if(data.showTermsAndConditions && !this.onPopUpTermsAndConditions){
        this.showTermsAndConditions(data);
        this.onPopUpTermsAndConditions = true;
      }
      else if (data && this.onPopUpTermsAndConditions) {
        this.alertGSTBeforePurchase(data.prodObj)
        this.onPopUpTermsAndConditions = false;
      }
      else {
        this.status = data.status;
      }
    },
    addToCart(pkg, pkgIndex, product, productIndex, parentId) {
      this.isProductAdded = true;
      this.packages[pkgIndex].product_list[productIndex].isAdded = true;
      this.packages[pkgIndex].product_list[productIndex].parent
        ? this.onChildAdd(product)
        : this.onParentAdd(product);
    },
    checkForStatus() {
      var status = this.$route.query.status;
      if (status && status.toUpperCase() == "SUCCESS") {
        this.onPaymentDialogOpen(true);
      } else if (status && status.toUpperCase() == "FAILED") {
        this.onPaymentDialogOpen(false);
      }
      if (status) {
        window.history.pushState({}, document.title, this.$route.path);
      }
    },
    onPaymentDialogOpen(isSuccess) {
      var amount = this.$route.query.amount || '';
      var product = this.$route.query.product || '';
      this.cComponent = "components/coordinator/subscription-details/PaymentPopUp";
      this.modalwidth = "580px";
      this.contentClass = isSuccess ? "modal-top-success" : "modal-top-failure";
      this.alertBoxData = { total_amount: amount, product_name: product };
      this.success = isSuccess;
      this.failure = !isSuccess;
      this.status = true;
    },
    showCart() {
      var showCart = false;
      if (this.packages && this.packages.length) {
        this.packages.forEach((pkg) => {
          if (pkg.product_list && pkg.product_list.length) {
            pkg.product_list.forEach((p) => {
              if (p.is_purchased == 0) {
                showCart = true;
              }
            });
          }
        });

        return showCart;
      }
    },
    buyNow(productId,couponCode,gstNumber) {
      var pId = [];
      if (productId) {
        pId.push(productId);
        this.modifyResetPackageData();
      }
      if (pId) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: pId,
          success_redirect,
          failure_redirect,
          coupon: couponCode,
          gst_number: gstNumber
        };
        this.createPackageOrder(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.generateDataForPayment(response.order);
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.$toasted.error("Please add atleast one package in cart.");
      }
    },
    buyPackages(couponCode,gstNumber) {
      let {product_ids} = this.getPackageDetails();
      
      if (product_ids.length > 0) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: product_ids,
          success_redirect,
          failure_redirect,
          coupon: couponCode,
          gst_number: gstNumber
        };
        this.createPackageOrder(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.generateDataForPayment(response.order);
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.$toasted.error("Please add atleast one package in cart.");
      }
    },
    generateDataForPayment(order) {
      this.orderId = order.tx_id;
      let phoneNumber = this.user.phone;
      let pd = {
        key: order.key,
        txnid: order.tx_id + "",
        amount: order.amount,
        firstname: this.user.name,
        email: this.user.email,
        phone: phoneNumber,
        productinfo: "" + order.productsForPurchase,
        surl: order.surl,
        furl: order.furl,
        hash: order.hash,
        mode: "dropout",
        udf1: order.udf1,
        udf2: order.udf2,
        udf3: order.udf3,
        udf5: "",
        pg_url:order.pg_url
    };
    this.order = pd;
      // this.launchBOLT(pd);
    },
    launchBOLT(pd) {
      let that = this;
      let handler = {
        responseHandler: function(BOLT) {
          that.checkTransactionStatus(BOLT);
        },
        catchException: function(BOLT) {
          that.handleBoltError(BOLT);
        },
      };
      bolt.launch(pd, handler);
    },
    handleBoltError(BOLT) {
      this.$toasted.error(BOLT.message);
    },
    checkTransactionStatus(BOLT) {
      if (BOLT.response.txnStatus == "CANCEL") {
        let postData = {
          order_id: this.orderId,
        };
        this.updateTransactionStatus(postData)
          .then((response) => {
            //  this.modifyResetPackageData();
            this.isAgreed = false;
            this.$toasted.success("Transaction Cancelled by User.");
          })
          .catch((err) => {
            this.$toasted.error("Error while updating transaction status.");
          });
      }
    },
    currentAmount() {
      let {currentAmount} = this.getPackageDetails();
      return currentAmount;
    },
    modifyResetPackageData() {
      this.isProductAdded = false;
      this.packages.map((pkg) => {
        return (pkg.product_list = pkg.product_list.map((p) => {
          return {
            ...p,
            ...{
              description: p.desc,
              isAdded: false,
              isDisabled: false
            },
          };
        }));
      });

      this.packages.sort(this.compare);
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const orderA = parseInt(a.order);
      const orderB = parseInt(b.order);

      let comparison = 0;
      if (orderA > orderB) {
        comparison = 1;
      } else if (orderA < orderB) {
        comparison = -1;
      }
      return comparison;
    },
    getIsProductPurchased(prodObj){                 
      return  prodObj.expiry_date? moment(prodObj.expiry_date) < moment():true;
    },
    getIsInstitutePurchased(prodObj){               
      return  prodObj.institute_purchased && !(prodObj.is_purchased) ? false : true;
    },
    isDivVisible(ptype){            
      const pkgType = this.packages.find((x) => x.product_type == ptype);
      if(pkgType && pkgType.product_list && pkgType.product_list.length){
      let tmpArry = pkgType.product_list.filter(x => x.institute_purchased===1 && !x.is_purchased);
      return tmpArry.length !== pkgType.product_list.length;
      }
    },
    buyCartPackages(){
      let {product_ids, packageObjToBuy} = this.getPackageDetails();
      let reqData = {
        product_ids : product_ids
      }
      this.getPriceDetails(reqData)
      .then((response) => {
        if(response){
          this.alertGSTBeforePurchase(packageObjToBuy, response);
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    getPackageDetails(){
      let product_ids = [];
      let packageObjToBuy = [];
      let currentAmount = 0;
      this.packages.forEach((pkg) => {
        pkg.product_list.forEach((p) => {
          if (p.isAdded == true) {
            product_ids.push(p.id);
            packageObjToBuy.push(p);
            currentAmount += p.total_amount;
          }
        });
      });
      return {product_ids, packageObjToBuy,currentAmount};
    },
    shouldShowMasterPyqProduct(prodObj) {
      if (this.user && this.user.batch_name === '2026') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return prodObj.id === constants.MODULES.MASTERPYQJEE26;
        } else {
          return prodObj.id === constants.MODULES.MASTERPYQNEET26;
        }
      } else if (this.user && this.user.batch_name === '2027') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return prodObj.id === constants.MODULES.MASTERPYQJEE27;
        } else {
          return prodObj.id === constants.MODULES.MASTERPYQNEET27;
        }
      } else if (this.user && this.user.batch_name === '2028') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return prodObj.id === constants.MODULES.MASTERPYQJEE28;
        } else {
          return prodObj.id === constants.MODULES.MASTERPYQNEET28;
        }
      }
      return false;
    }
  },
};
</script>
